module.exports = __webpack_public_path__ + "img/fa-3@3x.4bb7d1b5.png";